import React from 'react';
import { NoCategories } from '@Components/Category/NoCategories.component';

interface NoLoFCategoriesProps {
	handleAddCategoryClicked: () => void;
}

export const NoLoFCategories: React.FC<NoLoFCategoriesProps> = ({
	handleAddCategoryClicked,
}) => (
	<NoCategories
		section="lof"
		handleAddCategoryClicked={handleAddCategoryClicked}
	/>
);
